module.exports = __webpack_public_path__ + "static/img/10.03dadcf.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/2/2/sp/10.png
// module id = A6to
// module chunks = 0